import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobeStand = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M15 5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 1 0 0-17ZM15 8c3.04 0 5.5 2.46 5.5 5.5M25 3.5l-1.87 1.87M23.13 5.37A11.5 11.5 0 0 1 26.5 13.5 11.5 11.5 0 0 1 6.87 21.63M6.87 21.63 5 23.5M15 22v6M9.5 28h11",
				stroke: "white",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 5.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15 5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 1 0 0-17Z",
				style: { fill: "var(--sticker-pastel,#D0DBFF)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15 5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 1 0 0-17ZM15 8c3.04 0 5.5 2.46 5.5 5.5M25 3.5l-1.87 1.87M23.13 5.37A11.5 11.5 0 0 1 26.5 13.5 11.5 11.5 0 0 1 6.87 21.63M6.87 21.63 5 23.5M15 22v6M9.5 28h11",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				style: { stroke: "var(--sticker-dark,#505772)" }
			})
		]
	});
};
export default SvgGlobeStand;
